module.exports = __webpack_public_path__ + "img/MaryCarmen_Lopez.aac22e6d.webp";